import * as React from 'react';
import { types } from './types';
import { Icon } from '@ant-design/compatible';
import { createFromIconfontCN } from '@ant-design/icons';

const IconFont = createFromIconfontCN({
    scriptUrl: "//at.alicdn.com/t/c/font_2127485_qbqejsmnmok.js",
});

const MatchIcon = createFromIconfontCN({
    scriptUrl: "//at.alicdn.com/t/font_2336482_echhzzl8das.js",
});

export default class IconComponent extends React.Component<any> {

    render() {
        const { className, theme = 'outlined', type, color, style = {}, onClick, matchIcon, ...props } = this.props;
        // Rocket Icon
        if (matchIcon) return <MatchIcon type={`icon-${type}`} style={style} className={className} />;
        if (color) {
            style.color = color;
        }
        const iconType: string = type
            ? types.includes(type) || type.includes('anticon-')
                ? type
                : `anticon-${type}`
            : className
                ? className.split('\u0020').find((item: string) => item.includes('anticon-'))
                : '';
        return (
            types.includes(iconType)
                ? <Icon
                    onClick={onClick}
                    type={iconType}
                    theme={theme}
                    style={style}
                    className={className}
                />
                : <IconFont
                    onClick={onClick}
                    {...props}
                    type={iconType}
                    className={className}
                    style={style}
                />
        );
    }
}
